// extracted by mini-css-extract-plugin
module.exports = {"form":"registration_form__idbsN","spin":"registration_spin__3nYyt","submitButton":"registration_submitButton__3n_ri","agreement":"registration_agreement__1Fbz-"};